module.exports = __webpack_public_path__ + "a7a09c3f571c09ad456e5ab8b3407477.png";